import { Fragment } from 'react';

import { Dialog, DialogContent } from '@/components/ui/dialog';

import { AddRepresentative, EditRepresentative, RemoveRepresentativeModal } from './';

import { useRepresentative } from '../model';

const actionComponentMap = {
  add: AddRepresentative,
  edit: EditRepresentative,
};

const RepresentativeModalActions = () => {
  const { action, setInitialData } = useRepresentative();

  const ActionComponent =
    action && action in actionComponentMap ? actionComponentMap[action as keyof typeof actionComponentMap] : null;

  return (
    <Fragment>
      <Dialog open={action === 'add' || action === 'edit'} onOpenChange={setInitialData}>
        <DialogContent className="sm:max-w-115">{ActionComponent && <ActionComponent />}</DialogContent>
      </Dialog>

      <RemoveRepresentativeModal />
    </Fragment>
  );
};

export default RepresentativeModalActions;
